<template>
  <div class="bidding_module">
    <div class="bidding_banner">
      <img src="../../../../static/img/bidding/biddingbg.png" alt width="100%" />
    </div>
    <div class="bidding_body">
      <div class="bidding_item">
        <el-row :gutter="20">
          <el-col :span="5">
            <div>
              <div class="bid_son_items bid_space">
                <div
                  v-for="(bItem,index) in bidItemArr"
                  :key="index"
                  @click="bidModuleCtl(index)"
                  class="bid_son_item"
                  :class="{ activeType:activeIndex==index }"
                >{{bItem.name}}</div>
              </div>
              <div>
                <bid-link></bid-link>
              </div>
            </div>
          </el-col>
          <el-col :span="19">
            <div>
              <!-- 招标公告 -->
              <div v-show="isNote" class="bid_space">
                <bid-note ref="bidNote" @sendBack="sendBack"></bid-note>
              </div>
              <!-- 招标动态 -->
              <div v-show="isNews" class="bid_space">
                <bid-news ref="bidNews" @sendBack="sendBack"></bid-news>
              </div>
              <!-- 备案告知 -->
              <div v-if="isRecord" class="bid_space">
                <bid-record ref="bidCast" @sendBack="sendBack"></bid-record>
              </div>
              <!-- 政策法规 -->
              <div v-show="isLaw" class="bid_space">
                <bid-law ref="bidLaw" @sendBack="sendBack"></bid-law>
              </div>
              <!-- 普通公告 -->
              <div v-show="isOrdinary">
                <ordinary-notice ref="ordinaryNotice" @sendBack="sendBack"></ordinary-notice>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import bidRecord from './bidForcast'; // 备案告知
import bidLaw from './bidLaw'; // 政策法规
import bidNews from './bidNews'; // 招标动态
import bidNote from './bidNote'; // 招标公告
import ordinaryNotice from './ordinaryNotice'; // 普通公告
import bidLink from './link'; // 友情链接
export default {
  data() {
    return {
      isNote: true,
      isOrdinary: true,
      isNews: true, //
      isLaw: true,
      isRecord: true,
      defaultPath: '../../../static/img/blank.jpg',
      bidItemArr: [
        { name: '招标首页' },
        { name: '招标公告' },
        { name: '备案告知' },
        { name: '招标动态' },
        { name: '政策法规' },
        { name: '普通公告' }
      ],
      activeIndex: 0
    };
  },
  components: {
    bidRecord,
    bidLaw,
    bidNews,
    bidNote,
    bidLink,
    ordinaryNotice
  },
  methods: {
    bidModuleCtl(index) {
      this.activeIndex = index;
      switch (index) {
        case 0:
          this.isNote = true;
          this.isNews = true;
          this.isLaw = true;
          this.isRecord = true;
          this.isOrdinary = true;
          this.$refs.bidNote.initBidNoteData(1, 5, false);
          this.$refs.bidNews.initBidNewsData(1, 5, false);
          setTimeout(() => {
            this.$refs.bidCast.initBidCastData(1, 5, false);
          }, 10);
          this.$refs.bidLaw.initLawData(1, 5, false);
          break;
        case 1:
          this.isNote = true;
          this.isRecord = false;
          this.isNews = false;
          this.isLaw = false;
          this.isOrdinary = false;
          this.$refs.bidNote.initBidNoteData(1, 10, true);
          break;
        case 2:
          // 备案告知
          this.isRecord = true;
          this.isNote = false;
          this.isNews = false;
          this.isLaw = false;
          this.isOrdinary = false;
          setTimeout(() => {
            this.$refs.bidCast.initBidCastData(1, 10, true);
          }, 10);
          break;
        case 3:
          // 招标动态
          this.isNews = true;
          this.isNote = false;
          this.isLaw = false;
          this.isRecord = false;
          this.isOrdinary = false;
          this.$refs.bidNews.initBidNewsData(1, 10, true);
          break;
        case 4:
          this.isLaw = true;
          this.isNote = false;
          this.isNews = false;
          this.isRecord = false;
          this.isOrdinary = false;
          this.$refs.bidLaw.initLawData(1, 10, true);
          break;
        case 5:
          this.isLaw = false;
          this.isNote = false;
          this.isNews = false;
          this.isRecord = false;
          this.isOrdinary = true;
          this.$refs.bidLaw.initOrdinaryData(1, 10, true);
          break;
      }
    },
    sendBack(val) {
      switch (val) {
        case 1:
          this.isNote = true;
          this.isOrdinary = false;
          this.isNews = false;
          this.isLaw = false;
          this.isRecord = false;
          break;
        case 2:
          this.isRecord = true;
          this.isNote = false;
          this.isOrdinary = false;
          this.isNews = false;
          this.isLaw = false;
          break;
        case 3:
          this.isNews = true;
          this.isNote = false;
          this.isOrdinary = false;
          this.isLaw = false;
          this.isRecord = false;
          break;
        case 4:
          this.isOrdinary = true;
          this.isNews = false;
          this.isNote = false;
          this.isLaw = false;
          this.isRecord = false;
          break;
        case 5:
          this.isLaw = true;
          this.isOrdinary = false;
          this.isNews = false;
          this.isNote = false;
          this.isRecord = false;
          break;
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.bidding_module {
  width: 100%;
  background-color: #F8F8F8;
}

.bidding_body {
  width: 100%;
  min-height: 500px;
  padding: 20px 0;

  .bidding_item {
    width: 70%;
    margin: 0 auto;
    min-height: 500px;

    .bid_son_items {
      border-left: 1px solid #DCDFE6;
      border-top: 1px solid #DCDFE6;
      border-right: 1px solid #DCDFE6;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      background-color: #fff;

      .bid_son_item {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #DCDFE6;
        text-align: center;
      }

      .bid_son_item:hover {
        cursor: pointer;
        background-color: #F2F6FC;
      }
    }

    .bid_space {
      margin-bottom: 20px;
    }
  }
}

img {
  vertical-align: middle;
}

.activeType {
  color: #fff;
  background-image: url('../../../../static/img/companyinfors/abu-bak.png');
  border: 1px solid #00546D;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/bidding/bidding.vue